export default {
  loading: false,
  supervisor_stamps: [],
  supervisor_stamp: {},
  totalCount: 0,
};
